












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { auth } from '@/firebaseConfig.ts';

@Component
export default class AppHeader extends Vue {
  currentUser: firebase.User | null = auth.currentUser;

  get userEmail() {
    return this.currentUser ? this.currentUser.email : '';
  }

  // eslint-disable-next-line class-methods-use-this
  collapedMobileSidebar() {
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) sidebar.classList.toggle('active');
  }

  async signout() {
    try {
      await auth.signOut();
      this.$router.replace({ path: '/login' });
    } catch (err) {
      console.error(err);
    }
  }
}
